import { handleService } from './common'
const commonUrl = '/api/Area'
const url = {
  getListByPage: commonUrl + '/GetListByPage',
  Delete: commonUrl + '/Delete',
  Add: commonUrl + '/Add',
  Update: commonUrl + '/Update',
  GetInfo: commonUrl + '/Get'
}
export default {
  GetParkTable (data) {
    return handleService(url.getListByPage, data)
  },
  Delete (data) {
    return handleService(url.Delete, data, 'DELETE')
  },
  Add (data) {
    return handleService(url.Add, data, 'POST')
  },
  Update (data) {
    return handleService(url.Update, data, 'PUT')
  },
  GetInfo (data) {
    return handleService(url.GetInfo, data, 'GET')
  },

  // 支付接入查询
  GetParkPayData (data) {
    let url = '/api/Area/GetMerchant'
    return handleService(url, data)
  },

  // 商户号验证
  CheckWxPayCode (data) {
    let url = '/api/Area/Check'
    return handleService(url, data)
  },

  // 设置支付接入
  SetParkPay (data) {
    let url = '/api/Area/EditMerchant'
    return handleService(url, data, 'POST')
  }
}
